import {getMethod, putMethod} from '~/api'

async function get(companyId) {
    return await getMethod(`/api/notificationSettings/company/${companyId}`)
}

async function put(companyId, request) {
    return await putMethod(`/api/notificationSettings/company/${companyId}`, request)
}

export {get, put}
